<!-- Add this before the table -->
<div class="chips-container">
  <mat-chip-listbox
    [(ngModel)]="selectedChips"
    [multiple]="true"
    (change)="onChipSelectionChange($event)"
  >
    <!-- <mat-chip-option [selected]="selectedChips.includes('all')" value="all" color="primary">
    {{ labelService.getLabel('Tutto') }}
  </mat-chip-option> -->
    <mat-chip-option value="ready" color="accent">
      {{ labelService.getLabel("Pronte da inviare") }}
    </mat-chip-option>
    <mat-chip-option value="private" color="warn">
      {{ labelService.getLabel("Privati") }}
    </mat-chip-option>
    <mat-chip-option value="company" color="warn">
      {{ labelService.getLabel("Aziende") }}
    </mat-chip-option>
    <mat-chip-option value="credit_note_sdi" color="primary">
      {{ labelService.getLabel("Note di Credito SDI") }}
    </mat-chip-option>
    <mat-chip-option value="year" color="primary">
      {{ currentYear }}
    </mat-chip-option>
    <mat-chip-option
      value="date_range"
      [selected]="selectedChips.includes('date_range')"
      (click)="toggleDatePicker()"
    >
      @if (!dateRangePanel.startDate) {
        {{ labelService.getLabel("Intervallo Date") }}
      }
      @if (dateRangePanel.startDate) {
        {{ dateRangePanel.startDate | date: "dd/MM/yyyy" }} -
        {{ dateRangePanel.endDate | date: "dd/MM/yyyy" }}
      }
    </mat-chip-option>
  </mat-chip-listbox>

  <!-- Add this after mat-chip-listbox -->
  @if (dateRangePanel.isOpen) {
    <div class="date-range-panel">
      <div class="date-range-content">
        <mat-form-field appearance="fill">
          <mat-label>{{
            labelService.getLabel("Date inizio e fine")
          }}</mat-label>
          <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
            <input
              matStartDate
              formControlName="start"
              placeholder="Data Inizio"
            />
            <input matEndDate formControlName="end" placeholder="Data Fine" />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <div class="date-range-actions">
          <button mat-button class="button-white" (click)="resetDateRange()">
            {{ labelService.getLabel("Rimuovi") }}
          </button>
          <button
            mat-raised-button
            class="button-white"
            [disabled]="
              !dateRange.get('start')?.value || !dateRange.get('end')?.value
            "
            (click)="confirmDateRange()"
          >
            {{ labelService.getLabel("Conferma") }}
          </button>
        </div>
      </div>
    </div>
  }
</div>

<!-- Add this after the chips-container and before the table-container -->
@if (selectedInvoices.size > 0) {
  <div class="selection-summary">
    @if (selectedPrivateInvoices.length > 0) {
      <div class="summary-row">
        <div class="summary-info">
          <span
            >{{ labelService.getLabel("Fatture Private Selezionate") }}:
            {{ selectedPrivateInvoices.length }}</span
          >
          @if (!canSendInvoices("private")) {
            <span class="warning">
              {{ labelService.getLabel("Fatture non inviabili") }}:
              {{ getNotSendableInvoices("private") }}
            </span>
          }
          @if (!canDeleteInvoices("private")) {
            <span class="warning">
              {{ labelService.getLabel("Fatture non eliminabili") }}:
              {{ getNotDeletableInvoices("private") }}
            </span>
          }
        </div>
        <div class="summary-actions">
          <button
            mat-raised-button
            color="primary"
            [disabled]="!canSendInvoices('private')"
            (click)="onSendSelected('private')"
          >
            {{ labelService.getLabel("Invia a STS") }}
          </button>
          <button
            mat-raised-button
            color="warn"
            [disabled]="!canDeleteInvoices('private')"
            (click)="onDeleteSelected('private')"
          >
            {{ labelService.getLabel("Elimina") }}
          </button>
        </div>
      </div>
    }
    @if (selectedSDIInvoices.length > 0) {
      <div class="summary-row">
        <div class="summary-info">
          <span
            >{{ labelService.getLabel("Fatture SDI Selezionate") }}:
            {{ selectedSDIInvoices.length }}</span
          >
          @if (!canSendInvoices("sdi")) {
            <span class="warning">
              {{ labelService.getLabel("Fatture non inviabili") }}:
              {{ getNotSendableInvoices("sdi") }}
            </span>
          }
          @if (!canDeleteInvoices("sdi")) {
            <span class="warning">
              {{ labelService.getLabel("Fatture non eliminabili") }}:
              {{ getNotDeletableInvoices("sdi") }}
            </span>
          }
        </div>
        <div class="summary-actions">
          <button
            mat-raised-button
            color="primary"
            [disabled]="!canSendInvoices('sdi')"
            (click)="onSendSelected('sdi')"
          >
            {{ labelService.getLabel("Invia a SDI") }}
          </button>
          <button
            mat-raised-button
            color="warn"
            [disabled]="!canDeleteInvoices('sdi')"
            (click)="onDeleteSelected('sdi')"
          >
            {{ labelService.getLabel("Elimina") }}
          </button>
        </div>
      </div>
    }
  </div>
}

@if (invoices.length > 0 && !isLoadingInvoices) {
  <div class="table-container">
    <table
      mat-table
      [dataSource]="filteredInvoices"
      class="invoice-table"
      matSort
      (matSortChange)="onSort($event)"
    >
      <!-- Number Column -->
      <ng-container matColumnDef="number">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="progressivo_numero"
        >
          <div class="header-content">
            <span>{{ labelService.getLabel("number") }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">
          {{ invoice.progressivo_numero }}
        </td>
      </ng-container>
      <!-- Year Column -->
      <ng-container matColumnDef="year">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="progressivo_anno"
        >
          <div class="header-content">
            <span>{{ labelService.getLabel("year") }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">
          {{ invoice.progressivo_anno }}
        </td>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("status") }}
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.stato }}</td>
      </ng-container>
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="data">
          <div class="header-content">
            <span>{{ labelService.getLabel("date") }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.data }}</td>
      </ng-container>
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("type") }}
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.tipo }}</td>
      </ng-container>
      <!-- Client Column -->
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            @if (!showClientSearch) {
              <span>{{ labelService.getLabel("client") }}</span>
            }
            <div class="search-container" [class.active]="showClientSearch">
              <mat-icon class="search-icon" (click)="toggleClientSearch()">
                {{ showClientSearch ? "close" : "search" }}
              </mat-icon>
              @if (showClientSearch) {
                <div class="search-input-container">
                  <input
                    type="text"
                    class="search-input"
                    [value]="clientSearchValue"
                    (input)="onClientSearchChange($event)"
                    placeholder="Cerca cliente..."
                    #searchInput
                  />
                  @if (clientSearchValue) {
                    <mat-icon class="clear-icon" (click)="clearSearch()">
                      clear
                    </mat-icon>
                  }
                </div>
              }
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.client_name }}</td>
      </ng-container>
      <!-- Total Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("total") }}
        </th>
        <td mat-cell *matCellDef="let invoice">
          € {{ invoice.totale | number: "1.2-2" }}
        </td>
      </ng-container>
      <!-- Data Pagamento Column -->
      <ng-container matColumnDef="data_pagamento">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("Data Pagamento") }}
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.data_pagamento }}</td>
      </ng-container>
      <!-- Pagata Column -->
      <ng-container matColumnDef="pagata">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("Pagata") }}
        </th>
        <td mat-cell *matCellDef="let invoice">
          <mat-checkbox
            [checked]="invoice.pagata"
            [disabled]="!isDraftOrReadyStatus(invoice)"
            (change)="onPagataChange(invoice, $event)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let invoice">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            class="action-button"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="duplicateInvoice(invoice)">
              <mat-icon>content_copy</mat-icon>
              <span>{{ labelService.getLabel("duplicate") }}</span>
            </button>
            @if (invoice.modifiable) {
              <button mat-menu-item (click)="modifyInvoice(invoice)">
                <mat-icon>edit</mat-icon>
                <span>{{ labelService.getLabel("Modifica") }}</span>
              </button>
            }
            @if (isStsDraft(invoice)) {
              <button mat-menu-item (click)="promoteStsDraftToReady(invoice)">
                <mat-icon>publish</mat-icon>
                <span>Promuovi a Pronta</span>
              </button>
            }
            @if (isStsReady(invoice)) {
              <button mat-menu-item (click)="openStsSummary(invoice)">
                <mat-icon>visibility</mat-icon>
                <span>Guarda Riepilogo</span>
              </button>
            }
            @if (isStsSendActionVisible(invoice)) {
              <button
                mat-menu-item
                [disabled]="!canSendInvoice(invoice)"
                (click)="sendInvoice(invoice)"
              >
                <mat-icon>send</mat-icon>
                <span>{{ labelService.getLabel("Invia a STS") }}</span>
              </button>
            }
            @if (
              invoice.sendable &&
              (invoice.tipo === "Parcella SDI" ||
                invoice.tipo === "Nota di Credito SDI")
            ) {
              <button mat-menu-item (click)="sendInvoice(invoice)">
                <mat-icon>send</mat-icon>
                <span>{{ labelService.getLabel("Invia a SDI") }}</span>
              </button>
            }
            @if (
              invoice.tipo === "Parcella SDI" ||
              invoice.tipo === "Nota di Credito SDI"
            ) {
              <button mat-menu-item (click)="showNotifications(invoice)">
                <mat-icon>notifications</mat-icon>
                <span>{{ labelService.getLabel("Storico Notifiche") }}</span>
              </button>
            }
            @if (invoice.deletable) {
              <button mat-menu-item (click)="deleteInvoice(invoice)">
                <mat-icon>delete</mat-icon>
                <span>{{ labelService.getLabel("delete") }}</span>
              </button>
            }
            @if (isDraftOrReadyStatus(invoice)) {
              <button mat-menu-item (click)="modifyInvoicePaymentDate(invoice)">
                <mat-icon>date_range</mat-icon>
                <span>{{
                  labelService.getLabel("Modifica Data Pagamento")
                }}</span>
              </button>
            }
            @if (
              invoice.tipo === "Parcella Privati" && invoice.stato !== "Bozza"
            ) {
              <button mat-menu-item (click)="downloadInvoiceSTSPDF(invoice)">
                <mat-icon>download</mat-icon>
                <span>{{ labelService.getLabel("Scarica PDF") }}</span>
              </button>
            }
            @if (invoice.tipo === "Parcella SDI" && invoice.stato !== "Bozza") {
              <button mat-menu-item (click)="downloadInvoiceSDIPDF(invoice)">
                <mat-icon>download</mat-icon>
                <span>{{ labelService.getLabel("Scarica PDF") }}</span>
              </button>
            }
            @if (isInvoiceReadyOrSent(invoice)) {
              <button mat-menu-item (click)="sendEmailToClient(invoice)">
                <mat-icon>email</mat-icon>
                <span>{{
                  labelService.getLabel("Invia Email al cliente")
                }}</span>
              </button>
            }
            @if (isInvoiceSTS(invoice) && isInvoiceSTSSent(invoice)) {
              <button mat-menu-item (click)="showReceipt(invoice)">
                <mat-icon>receipt</mat-icon>
                <span>{{ labelService.getLabel("Mostra Ricevuta") }}</span>
              </button>
            }
            @if (isStsCreditNoteEligible(invoice)) {
              <button mat-menu-item (click)="openStsCreditNote(invoice)">
                <mat-icon>note_add</mat-icon>
                <span>Emetti Nota di Credito</span>
              </button>
            }
            @if (isInvoiceReady(invoice)) {
              <button mat-menu-item (click)="revertInvoice(invoice)">
                <mat-icon>arrow_downward</mat-icon>
                <span>{{ labelService.getLabel("Converti a Bozza") }}</span>
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>
      <!-- Select Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="masterToggle()"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            [aria-label]="'Select all invoices'"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onRowSelection(row)"
            [checked]="isSelected(row)"
            [aria-label]="'Select invoice'"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}

@if (isLoadingInvoices) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}

@if (invoices.length === 0 && !isLoadingInvoices) {
  <div class="no-data-container">
    <img src="assets/imgs/undraw/undraw_empty.svg" alt="Nessun Documento" />
    <span>Nessuna fattura presente</span>
  </div>
}
